import { FacebookPixel } from '../FacebookPixel';

const sendPixelEstimator =
  (
    event:
      | 'Valutatore Indirizzo Imm. inserito'
      | 'Valutatore Valutatore Step 3 completato'
      | 'Valutatore Completato'
  ) =>
    () => {
      FacebookPixel.trackCustom(event);
    };

export const sendPixelEstimatorAddress = sendPixelEstimator('Valutatore Indirizzo Imm. inserito');
export const sendPixelEstimatorConditions = sendPixelEstimator('Valutatore Valutatore Step 3 completato');
export const sendPixelEstimatorComplete = sendPixelEstimator('Valutatore Completato');
